import { call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import { FETCH_MODELS_REQUEST, fetchModelsFailure,  fetchModelsSuccess } from '../actions/modelAction';
import { getBaseUrl } from '../utils/getBaseUrl';

const API_BASE_URL = `${getBaseUrl()}/api/canopus/models?type=text`;
const getAuthToken = () => localStorage.getItem('authToken');

function* fetchModelsSaga(action) {
    try {
      const token =  getAuthToken();
      const { page = 1, limit = 1, search = '' } = action.payload || {};
      const response = yield call(axios.get, API_BASE_URL, {
        headers: { Authorization: `Bearer ${token}` },
        params: { page, limit, search },
      });
      
      yield put(fetchModelsSuccess(response.data));
    } catch (error) {
      yield put(fetchModelsFailure(error.message));
    }
}

export default function* modelSaga() {
  yield takeLatest(FETCH_MODELS_REQUEST, fetchModelsSaga);
}